module.exports = __webpack_public_path__ + "img/new-card.50dc67c8.png";